module.exports = __webpack_public_path__ + "img/dy03.08214251.png";